import { render } from "./modalAutoresponder.vue?vue&type=template&id=61770fc0"
import script from "./modalAutoresponder.vue?vue&type=script&lang=js"
export * from "./modalAutoresponder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__